export default class StorageService {
  static getApiToken = async (): Promise<string | null> => {
    return localStorage.getItem("_api_token");
  };

  static setApiToken = async (token: string): Promise<void> => {
    return localStorage.setItem("_api_token", token);
  };

  static removeApiToken = async (): Promise<void> => {
    return localStorage.removeItem("_api_token");
  };

  static getTermsAccepted = async (): Promise<string | null> => {
    return localStorage.getItem("_is_terms_accepted");
  };

  static setTermsAccepted = async (val: string): Promise<void> => {
    return localStorage.setItem("_is_terms_accepted", val);
  };

  static setUserDeviceToken = async (deviceToken: string): Promise<void> => {
    return localStorage.setItem("_deviceToken", deviceToken);
  };

  static getUserDeviceToken = async (): Promise<string | null> => {
    return localStorage.getItem("_deviceToken");
  };

  static setPreVerifyData = async (token: string): Promise<void> => {
    return localStorage.setItem("_preVerificationToken", token);
  };

  static getPreVerifyData = async (): Promise<string | null> => {
    return localStorage.getItem("_preVerificationToken");
  };

  static getPostVerifyData = async (): Promise<string | null> => {
    return localStorage.getItem("_postVerificationToken");
  };

  static setPostVerifyData = async (token: string): Promise<void> => {
    return localStorage.setItem("_postVerificationToken", token);
  };

  static removePrePostVerifyData = async (): Promise<void> => {
    localStorage.removeItem("_postVerificationToken");
    localStorage.removeItem("_preVerificationToken");
    return;
  };

  static clearStorage = async (): Promise<void> => {
    const _userDeviceToken: any = await this.getUserDeviceToken();
    localStorage.clear();
    await this.setUserDeviceToken(_userDeviceToken);
    return;
  };

  // used for market plans
  static setMarketPlansUrl = async (key: string, value: string): Promise<void> => {
    return localStorage.setItem(key, value);
  };

  static getMarketPlansUrl = async (): Promise<string | null> => {
    return localStorage.getItem("planUUID");
  };

  static removeMarketPlansUrl = async (): Promise<void> => {
    return localStorage.removeItem("planUUID");
  };
}
